export default "__VITE_ASSET__nq28Jvw9__"